import { render, staticRenderFns } from "./CRUDComponent.vue?vue&type=template&id=319050eb&scoped=true"
import script from "./CRUDComponent.vue?vue&type=script&lang=js"
export * from "./CRUDComponent.vue?vue&type=script&lang=js"
import style0 from "./CRUDComponent.vue?vue&type=style&index=0&id=319050eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319050eb",
  null
  
)

export default component.exports